module.exports = __webpack_public_path__ + "img/not-win-icon@2x-v1.5bb84ac6.png";